import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {takeUntil} from 'rxjs';
import {AuthenticatedBaseComponent} from '../../../../authenticated-base.component';
import {ContentHeaderService} from '../../../../../services/content-header.service';
import {TitleService} from '../../../../../services/title.service';
import {TabSwitcherComponent} from '../../../../../components/tab-switcher/tab-switcher.component';
import {TableComponent} from '../../../../../components/table/table.component';
import Process = Backend.App.Resources.Dashboard.QualityManagement.Process;
import {ProcessTabSwitcherComponent} from '../../process-tab-switcher.component';

@Component({
  selector: 'app-authenticated-quality-management-processes-versions-index',
  templateUrl: './index.component.html',
  imports: [
    ReactiveFormsModule,
    TabSwitcherComponent,
    TableComponent,
    ProcessTabSwitcherComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  public process?: Process;

  public constructor(
    protected override readonly cdr: ChangeDetectorRef,
    protected override readonly translate: TranslateService,
    protected override readonly contentHeaderService: ContentHeaderService,
    protected override readonly titleService: TitleService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super(cdr, translate, contentHeaderService, titleService);
  }

  public ngOnInit() {
    this.activatedRoute.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      const process: Process | undefined = data['process'];

      if (process) {
        this.process = process;

        this.titleService.setTitle('authenticated.quality-management.processes.versions.index.title');
      }
    });
  }
}
